export enum StatisticsEvents {
  SWITCH_TAB_PROFILE = 'switch_tab_profile',
  LEARNING_TIME_FILTER_CHANGED = 'change_learning_time_filter',
  REWARDS_TIME_FILTER_CHANGED = 'change_rewards_time_filter',
  LEARNING_CATEGORY_FILTER_CHANGED = 'change_learning_category_filter',
  PRODUCT_CARD_FILTER_CHANGED = 'change_product_card_filter',
  COLLAPSE_PRODUCT_CARD = 'collapse_product_card',
  EXPAND_PRODUCT_CARD = 'expand_product_card',
  PRODUCT_TITLE_CLICKED = 'clicked_product_title',
  CLICK_RETAKE_BUTTON = 'click_retake_button',
}

export enum StatisticsFilters {
  LEARNING_TAB_TIME = 'learning_tab_time_filter',
  LEARNING_TAB_PRODUCT = 'learning_tab_product_filter',
  REWARDS_TAB_TIME = 'rewards_tab_time_filter',
  PRODUCT_CARD_TIME = 'product_card_time_filter',
}

export enum StatisticsTabs {
  PROFILE_CARD = 'profile_card',
}
